import { IS_PREVIEW } from "@/utils/get-service";
import { confirmPayment } from "./previewPaymentService";
import type { SubmissionSuccessResponse } from "@/types/Payment";
import type { DonationFormState } from "@/stores/donationFormStore";

// The backend signs `view` into a shared preview link (#1109), so a reviewer can
// open the thank-you copy without walking the whole form. Outside preview the
// parameter means nothing: a real donor only reaches the page by donating.
export const PREVIEW_THANK_YOU_VIEW = "thank-you";

export function opensOnPreviewThankYou(searchParams: URLSearchParams): boolean {
  return IS_PREVIEW && searchParams.get("view") === PREVIEW_THANK_YOU_VIEW;
}

// Nobody chose an amount on this path, so the page shows the form's default.
function placeholderAmount(
  state: Pick<
    DonationFormState,
    "donationAmount" | "donationType" | "defaultDonationAmounts"
  >,
): number {
  const { donationAmount, donationType, defaultDonationAmounts } = state;
  const defaultAmount = donationType
    ? defaultDonationAmounts[donationType]
    : null;

  return donationAmount ?? defaultAmount ?? 0;
}

export function previewThankYouResponse(
  formId: number,
  state: Parameters<typeof placeholderAmount>[0],
): Promise<SubmissionSuccessResponse> {
  return confirmPayment({
    form_id: formId,
    session_id: "preview-thank-you",
    fields: { amount: { amount: placeholderAmount(state) } },
    payment: { gateway_payload: {} },
  });
}
